module.exports = __webpack_public_path__ + "img/img5.7951278e.svg";